module.exports = __webpack_public_path__ + "img/login-banner.f6ad7324.png";